import React from 'react';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { logout } from './actions/User';
import LoaDocuments from './components/LoaDocuments/LoaDocuments';
import MainPage from './components/LoaDocuments/MainPage';
import ModifyProducts from './components/ModifyProducts/ModifyProducts';
import Page404 from './components/Page404/Page404';
import PrivateRoute from './components/PrivateRoute';
import Authentication from './containers/2FA';
import Calls from './containers/Calls';
import Companies from './containers/Companies';
import EpikBoxDetails from './containers/epikBoxes/EpikBoxDetails';
import EpikBoxes from './containers/epikBoxes/BoxList';
import Licenses from './containers/Licenses';
import Projects from './containers/Projects';
import Help from './containers/Help';
import Fax from './containers/Fax';
import Oobm from './containers/oobm';
import Home from './containers/Home';
import Login from './containers/Login';
import BoxCheck from './containers/BoxCheck';
import NewPassword from './containers/NewPassword';
import Numbers from './containers/Numbers';
import Reports from './containers/Reports';
import Profile from './containers/Profile';
import Fulfillment from './containers/FullFilment';
// import Proposals from './containers/Proposals';
// // import ProposalGenerator from './containers/ProposalsGenerator';
// import ProposalCreator from './containers/ProposalsCreator';
// import ProposalsSign from './containers/ProposalsSign';
import Provisioning from './containers/Provisioning';
import ResetPassword from './containers/ResetPassword';
import Users from './containers/Users';
import CustomTemplate from './containers/CustomTemplate';
import PermissionsUI from './components/PermissionsGroup/PermissionUi'
import Vmails from './containers/Vmails';
import Porting from './containers/Provisioning/Porting';
import SystemLog from './containers/SystemLogs';
import DashboardMonitor from './containers/DashboardMonitor';
import Faxes from './containers/Faxes';
import Infrastructure from './components/Infrastructure/Infrastructure';
import LoginHistory from './components/LoginHistory';
import AccountRequest from './containers/AccountRequest';
import RequestsList from './components/RequestsList';
import AdminDashboard from './containers/AdminDashboard';
import PcapLookup from './components/PcapLookup';
import Servers from './containers/Servers';

// company group manager added
const Layout = () => {
  return (
    <Router>
      <Switch>
        <PrivateRoute exact path="/" component={Home} />
        <PrivateRoute
          exact
          path="/calls"
          component={Calls}
          roles={[
            'admin',
            'enterpriseAdmin',
            'companyGroupManager',
            'superAdmin',
            'companyGroupAdmin',
            'supportEngineer',
          ]}
        />
        <PrivateRoute
          exact
          path="/legacy-fax"
          component={Fax}
          roles={[
            'user',
            'admin',
            'enterpriseAdmin',
            'companyGroupManager',
            'superAdmin',
            'companyGroupAdmin',
            'supportEngineer',
          ]}
        />
         <PrivateRoute
          exact
          path="/oobm"
          component={Oobm}
          roles={[
            'user',
            'admin',
            'enterpriseAdmin',
            'companyGroupManager',
            'superAdmin',
            'companyGroupAdmin',
            'supportEngineer',
          ]}
        />
        <PrivateRoute
          exact
          path="/fax"
          component={Faxes}
          roles={[
            'user',
            'admin',
            'enterpriseAdmin',
            'companyGroupManager',
            'superAdmin',
            'companyGroupAdmin',
            'supportEngineer',
          ]}
        />
        <PrivateRoute
          exact
          path="/users"
          component={Users}
          roles={[
            'user',
            'admin',
            'enterpriseAdmin',
            'companyGroupManager',
            'superAdmin',
            'companyGroupAdmin',
          ]}
        />
                <PrivateRoute
          exact
          path="/templates"
          component={CustomTemplate}
          roles={[
            'user',
            'admin',
            'enterpriseAdmin',
            'companyGroupManager',
            'superAdmin',
            'companyGroupAdmin',
          ]}
        />
        <PrivateRoute
          exact
          path="/users/permissionsGroup"
          component={PermissionsUI}
          roles={[
            'superAdmin',
          ]}
        />
        <PrivateRoute
          exact
          path="/fulfillment"
          component={Fulfillment}
          roles={[
            'user',
            'admin',
            'enterpriseAdmin',
            'companyGroupManager',
            'superAdmin',
            'companyGroupAdmin',
          ]}
        />
        <PrivateRoute
          exact
          path="/servers"
          component={Servers}
          roles={[
            'user',
            'admin',
            'enterpriseAdmin',
            'companyGroupManager',
            'superAdmin',
            'companyGroupAdmin',
          ]}
        />
        <PrivateRoute exact path="/profile" component={Profile} />
        <PrivateRoute exact path="/login-history" component={LoginHistory} />
        <PrivateRoute exact path="/system-log" component={SystemLog} roles={['superAdmin']} />
        <PrivateRoute
          exact
          path="/dashboard-monitor"
          component={DashboardMonitor}
          roles={['superAdmin', 'companyGroupAdmin']}
        />
        <PrivateRoute
          exact
          path="/admin-dashboard"
          component={AdminDashboard}
          roles={['superAdmin']}
        />
               <PrivateRoute
          exact
          path="/admin-dashboard"
          component={AdminDashboard}
          roles={['superAdmin']}
        />
        <PrivateRoute exact path="/pcap-lookup" component={PcapLookup} roles={['superAdmin']} />

        <PrivateRoute
          exact
          path="/companies"
          component={Companies}
          roles={['superAdmin', 'companyGroupAdmin', 'companyGroupManager']}
        />
        <PrivateRoute
          exact
          path="/vmails"
          component={Vmails}
          roles={[
            'admin',
            'enterpriseAdmin',
            'companyGroupManager',
            'superAdmin',
            'user',
            'companyGroupAdmin',
          ]}
        />
        <PrivateRoute
          exact
          path="/boxes"
          component={EpikBoxes}
          roles={[
            'admin',
            'enterpriseAdmin',
            'companyGroupManager',
            'superAdmin',
            'companyGroupAdmin',
            'supportEngineer',
          ]}
        />
        <PrivateRoute
          exact
          path="/licenses"
          component={Licenses}
          roles={[
            'admin',
            'enterpriseAdmin',
            'companyGroupManager',
            'superAdmin',
            'companyGroupAdmin',
          ]}
        />
        <PrivateRoute
          exact
          path="/projects"
          component={Projects}
          roles={[
            'admin',
            'enterpriseAdmin',
            'companyGroupManager',
            'superAdmin',
            'companyGroupAdmin',
          ]}
        />
        <PrivateRoute
          exact
          path="/help"
          component={Help}
          roles={[
            'admin',
            'enterpriseAdmin',
            'companyGroupManager',
            'superAdmin',
            'companyGroupAdmin',
          ]}
        />
        <PrivateRoute
          exact
          path="/boxes/:id"
          component={EpikBoxDetails}
          roles={[
            'admin',
            'enterpriseAdmin',
            'companyGroupManager',
            'superAdmin',
            'companyGroupAdmin',
            'supportEngineer',
          ]}
        />
        {/* <PrivateRoute
          exact
          path="/proposals"
          component={Proposals}
          roles={['agent', 'superAdmin', 'quoteToolAdmin']}
        />
        <PrivateRoute
          exact
          path="/proposals-creator"
          component={ProposalCreator}
          roles={['agent', 'superAdmin', 'quoteToolAdmin']}
        />
        <PrivateRoute
          exact
          path="/proposals-creator/:id/edit"
          component={ProposalCreator}
          roles={['agent', 'superAdmin', 'quoteToolAdmin']}
        />
        <PrivateRoute
          exact
          path="/proposals-creator/:id/view"
          component={ProposalCreator}
          roles={['agent', 'superAdmin', 'quoteToolAdmin']}
        /> */}
        <PrivateRoute
          exact
          path="/modify-products"
          component={ModifyProducts}
          roles={['superAdmin']}
        />
        <PrivateRoute exact path="/numbers" component={Numbers} />
        <PrivateRoute exact path="/reports" component={Reports} />

        <PrivateRoute
          exact
          path="/provisioning/new-number"
          key="newnumber" // need to add key just so react can figure out the tree changed
          component={Provisioning}
          roles={['superAdmin', 'companyGroupAdmin', 'supportEngineer']}
        />
        <PrivateRoute
          path="/provisioning/porting"
          key="porting" // need to add key just so react can figure out the tree changed
          component={Porting}
          roles={['superAdmin', 'companyGroupAdmin', 'supportEngineer']}
        />
        <PrivateRoute
          exact
          path="/provisioning/e911"
          key="e911" // need to add key just so react can figure out the tree changed
          component={Provisioning}
          roles={['superAdmin', 'companyGroupAdmin', 'supportEngineer']}
        />
        <PrivateRoute
          exact
          path="/provisioning/routing"
          key="routing" // need to add key just so react can figure out the tree changed
          component={Provisioning}
          roles={['superAdmin', 'companyGroupAdmin', 'supportEngineer']}
        />
        <PrivateRoute
          exact
          path="/infrastructure"
          key="infrastructure"
          component={Infrastructure}
          roles={['superAdmin', 'supportEngineer']}
        />
           <PrivateRoute
          exact
          path="/template"
          key="template"
          component={Infrastructure}
          roles={['superAdmin', 'supportEngineer']}
        />
        <PrivateRoute
          exact
          path="/users/approval-requests"
          key="approval-requests"
          component={RequestsList}
          roles={['superAdmin']}
        />
        <Route exact path="/login" component={Login} />
        <Route exact path="/boxcheck" component={BoxCheck} />
        <Route exact path="/2fa" component={Authentication} />
        <Route exact path="/reset-password" component={ResetPassword} />
        <Route exact path="/account-request" component={AccountRequest} />
        <Route exact path="/reset/:id" component={NewPassword} />
        <Route exact path="/sampleLOA" component={LoaDocuments} />
        {/* <Route exact path="/proposals/:uuid/sign" component={ProposalsSign} />
        <Route exact path="/proposals/:uuid" component={ProposalsSign} />
        <Route exact path="/proposals/:uuid/frontpage" component={MainPage} /> */}

        <Route component={Page404} />
      </Switch>
    </Router>
  );
};

const mapStateToProps = store => ({
  theme: store.AppState.theme,
  user: store.AppState.user,
});

const mapDispatchToProps = dispatch => ({
  logout: token => dispatch(logout(token)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Layout);
